import React from "react";

export const LinkIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        stroke="#113357"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M8.666 10.825c.238.227.522.406.836.529a2.72 2.72 0 0 0 1.982 0c.314-.123.598-.302.836-.529l2.924-2.72c.484-.451.756-1.063.756-1.7 0-.638-.272-1.25-.756-1.7A2.69 2.69 0 0 0 13.416 4c-.685 0-1.342.253-1.827.704l-.365.34"
      ></path>
      <path
        stroke="#113357"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M11.334 8.485a2.6 2.6 0 0 0-.836-.529 2.72 2.72 0 0 0-1.982 0 2.6 2.6 0 0 0-.836.529l-2.923 2.72a2.32 2.32 0 0 0-.757 1.7c0 .638.272 1.25.757 1.7.484.452 1.142.705 1.827.705s1.342-.253 1.827-.704l.365-.34"
      ></path>
    </svg>
  );
};
